import classNames from 'classnames';
import React from 'react';
import * as styles from './SelectEntityOption.module.scss';

export interface SelectEntityOptionProps {
  disabled?: boolean;
  icon?: React.ReactNode;
  label: React.ReactNode;
  secondary?: React.ReactNode;
  secondaryTop?: React.ReactNode;
}

const SelectEntityOption = React.forwardRef<
  HTMLDivElement,
  SelectEntityOptionProps
>(
  (
    {
      disabled = false,
      icon = null,
      label = null,
      secondary = null,
      secondaryTop = null,
    }: SelectEntityOptionProps,
    ref,
  ) => (
    <div
      className={classNames(styles.container, {
        [styles.disabled]: disabled,
      })}
      ref={ref}
      tabIndex={-1}
    >
      {!!icon && <div className={styles.icon}>{icon}</div>}
      <div className={styles.info}>
        {!!secondaryTop && (
          <div className={styles.secondary}>{secondaryTop}</div>
        )}
        <div className={styles.label}>{label}</div>
        {!!secondary && <div className={styles.secondary}>{secondary}</div>}
      </div>
    </div>
  ),
);

export default SelectEntityOption;
